import image1 from '../images/memberships/Enmascarar grupo 7.png';
import image2 from '../images/memberships/Enmascarar grupo 6.png';

import first from '../images/memberships/first.png';
import diamond from '../images/memberships/diamond.png';

const memberships = [
	{
		id: 0,
		image: image2,
		icon: diamond,
		title: 'Standard',
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		prices: [
			{
				price: '2.390.264 COP',
			},
			{
				price: '2.309 SOLES',
			},
			{
				price: '568 Euros',
			},
			{
				price: '551.287 ARS',
			},
			{
				price: '10.282 MXN',
			},
			{
				price: '789 USD',
			},
		],
		priceUSD: '789 USD',
		price_before: {
			CO: '3.499.182 COP',
			PE: '3.394 SOLES',
			EC: '899 USD',
			ES: '835 Euros',
			AR: '809.259 ARS',
			MX: '15.401 MXN',
			ALL: '1170 USD',
		},
		items: [
			{
				item: 'Entrenamientos Plan Standard.',
				more: 'Tendrás a tu disposición todo el contenido del máster.',
			},
			{
				item: '6 meses de feedback en vivo.',
				more: 'Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.',
			},
			{
				item: 'Acceso por un año al contenido.',
				more: 'El año de acceso se empieza a contar a partir de la activación del contenido en tu cuenta..',
			},
			{ item: 'Acceso a Discord privado', more: null },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				class: 'paypal',
				url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTc4OSZpZD1N4XN0ZXIgZW4gQmxlbmRlciBwYXJhIEFuaW1hY2nzbiB5IFZpZGVvanVlZ29zIEVzdOFuZGFyLSBQVw==',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagar con Tarjeta',
				class: 'card',
				url: 'https://checkout.wompi.co/l/Emv7SP',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
	{
		id: 1,
		image: image1,
		icon: first,
		title: 'Grow',
		temario: 'https://drive.google.com/file/d/11S4HVWN2oJP_qymckLYLZxP7__Shl2se/view?usp=sharing',
		prices: [
			{
				price: '3.244.699 COP',
			},
			{
				price: '2.983,72 SOLES',
			},
			{
				price: '740,35 Euros',
			},
			{
				price: '745.067,50 ARS',
			},
			{
				price: '14.871,71 MXN',
			},
			{
				price: '949 USD',
			},
		],
		priceUSD: '949 USD',
		price_before: {
			CO: '4.049.440 COP',
			PE: '',
			EC: '',
			ES: '',
			AR: '',
			MX: '',
			ALL: '1.550 USD',
		},
		items: [
			{
				item: 'Entrenamientos Plan Grow.',
				more: 'El contenido del máster de irá liberando por partes a medida que vayas pagando las cuotas.',
			},
			{
				item: '7 meses de feedback en vivo.',
				more: 'Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.',
			},
			{
				item: 'Acceso por un año + 4 meses de regalo.',
				more: 'El año de acceso se empieza a contar a partir de la activación del primer contenido. Te recomendamos revisar los términos y condiciones de financiación.',
			},
			{ item: 'Contenido adicional.', more: null },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				class: 'paypal',
				url: 'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTk0OSZpZD1N4XN0ZXIgZW4gQmxlbmRlciBwYXJhIEFuaW1hY2nzbiB5IFZpZGVvanVlZ29zIEdyb3cgLSBQVw==',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagar con Tarjeta',
				class: 'card',
				url: 'https://checkout.wompi.co/l/b3yJLH',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
];

export default memberships;
